exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SearchInput___3_D7A {\n  flex: 1 1;\n  display: flex;\n  align-items: center;\n}\n\n.Input___3Kf09 {\n  flex: 1 1 100px;\n  width: 100px;\n  font-size: var(--font-size-sans-large);\n  outline: none;\n  border: none;\n  background-color: var(--color-background);\n  color: var(--color-text);\n  padding-left: 1.5rem;\n  margin-left: -1rem;\n}\n\n.InputIcon___1HrXN {\n  pointer-events: none;\n  z-index: 2;\n  color: var(--color-dimmer);\n}\n\n.IndexLabel___2cd8c {\n  color: var(--color-dim);\n  font-size: var(--font-size-sans-normal);\n  white-space: pre;\n}\n\n.LeftVRule___wcxjb,\n.RightVRule___cvpx8 {\n  height: 20px;\n  width: 1px;\n  background-color: var(--color-border);\n}\n.LeftVRule___wcxjb {\n  margin: 0 0.25rem 0 0.5rem;\n}\n.RightVRule___cvpx8 {\n  margin: 0 0.5rem 0 0.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"SearchInput": "SearchInput___3_D7A",
	"Input": "Input___3Kf09",
	"InputIcon": "InputIcon___1HrXN",
	"IndexLabel": "IndexLabel___2cd8c",
	"LeftVRule": "LeftVRule___wcxjb",
	"RightVRule": "RightVRule___cvpx8"
};